module.exports = __webpack_public_path__ + "static/media/super_soldier.46a727ce.gif";


//////////////////
// WEBPACK FOOTER
// ./src/modules/wechatShare/components/images/super_soldier.gif
// module id = 893
// module chunks = 0